import { getAllProducts } from "@/common/services/product.api";
import { getCostCenters } from "@/common/services/purchaseCostCenter.api";
import { useQuery } from "@tanstack/react-query";

export const useGetAllProducts = () => {
  return useQuery({
    queryKey: ["all-products"],
    queryFn: async () => {
      const response = await getAllProducts();
      if (!response.data) {
        throw new Error("Erro ao buscar produtos");
      }
      return response.data.map((product) => ({
        productId: product._id,
        description: product.name,
      }));
    },
    refetchOnWindowFocus: false,
  });
}

export const useGetCostCenter = () => {
  return useQuery({
    queryKey: ["cost-centers"],
    queryFn: async () => {
      const response = await getCostCenters();
      if (!response.data) {
        throw new Error("Erro ao buscar centros de custo");
      }
      return response.data
    },
    refetchOnWindowFocus: false,
  });
}
